import * as React from 'react';
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Button ,Card,CardContent,TextField,FormControl,InputLabel,Select,MenuItem,Typography} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { investorApi } from '../../api/api';

const KYC = () => {
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  const [statusFilter,setStatusFilter]=useState("All");
  const [searchQuery,setSearchQuery]=useState("");

  const handleStatusFilter=(e)=>{
    setStatusFilter(e.target.value);
  }

  const filteredData = rows.filter((row)=>
  {
     const matchesStatus =
    statusFilter === "All" || row.Status === statusFilter;

  const matchesSearch =
    searchQuery === "" ||
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
       return (
    matchesSearch &&
    matchesStatus 
  );
  });

  useEffect(() => {
    const fetchKycDetails = async () => {
      try {
        const response = await investorApi.getKycDetails();
        setRows(response.data);
      } catch (error) {
        console.error("Error fetching KYC details:", error);
      }
    };

    fetchKycDetails();
  }, []);
  // console.log(rows);
  const handleAction = (row) => {
    navigate(`/kyc/investorDetails`, { state: row });
  };

  const getStatusColor = (status) => {
    const colors = {
      'InProgress': 'red',
      'Rejected': 'blue',
      'Completed': 'green'
    };
    return colors[status] || '#000000';
  };

  const columns = [
    { field: "id", headerName: "ID", width: 70 },
    { field: "InvestorName", headerName: "User Name", width: 300 },
    { field: "mobileNumber", headerName: "Mobile Number", width: 250,  renderCell: params => (
        <Typography sx={{ color: '#0871c5' }}>
          {params.value}
        </Typography>
      ), },
    { 
      field: "Status", 
      headerName: "Status", 
      width: 220,
      renderCell: (params) => (
        <div style={{ color: getStatusColor(params.value), fontWeight: 'bold' }}>
          {params.value}
        </div>
      )
    },
    {
  field: "Action",
  headerName: "Action",
  width: 120,
  renderCell: (params) => {
    // const isCompleted = params.row.Status === "Completed";

    return (
      <Button
        variant="contained"
        onClick={() => handleAction(params.row)}
        // disabled={isCompleted} 
      >
        Update
      </Button>
    );
  }
},
  ];

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
      <Box sx={{ flexGrow: 1,  borderRadius: '5px' }}>
        <Grid container spacing={2}>
          <Grid item xs={8}>
            <h3>KYC</h3>
          </Grid>
        </Grid>
         <Card
          sx={{
            flexGrow: 1,
            border: "1px solid lightgray",
            borderRadius: "5px",
            marginBottom:2
          }}
        >
          <CardContent>
            <Grid container spacing={2} alignItems="center">
              {/* Search Field */}
              <Grid item xs={12} sm={6} md={3}>
                <TextField
                  label="Search By Key words"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '15px',
                    },
                  }}
                />
              </Grid>
               <Grid
                      item
                      xs={6}
                      sm={4}
                      md={2}
                      sx={{ textAlign: { xs: "left", sm: "right" }, pt: { xs: 0, sm: 1.25 } }}
                    >
                      <FormControl variant="outlined" size="small" fullWidth>
                        <InputLabel>Status</InputLabel>
                        <Select
                          value={statusFilter}
                          onChange={handleStatusFilter}
                          label="Status"
                        >
                          <MenuItem value="All">All</MenuItem>
                          <MenuItem value="Completed">Completed</MenuItem>
                          <MenuItem value="Rejected">Rejected</MenuItem>
                          <MenuItem value="InProgress">InProgress</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
        <div style={{ height: 400, width: '100%' }}>
          <DataGrid
            rows={filteredData}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 25]}
            disableSelectionOnClick
            autoHeight={false}
           sx={{
              height: 650,
              border: '1px solid #ccc',
              borderRadius: 2,
              fontSize: '0.9rem',
              backgroundColor: '#ffffff',
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#f0f0f0ff',
              },
              '& .MuiDataGrid-cell': {
                color: '#333',
                borderBottom: '1px solid #ddd',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f0f0f0ff',
                color: 'black',
                fontWeight: 'bold',
              },
              '& .MuiTablePagination-root': {
                fontSize: '0.875rem',
              },
            }}
          />
        </div>
      </Box>
    </Box>
  );
};

export default KYC;
